import React from 'react'
// import { CardViewIcon, ListViewIcon } from '../../../assets/logos/icons'
import { Grid } from '@material-ui/core';

const ViewType = (props) => {
    const {
        viewAsCards,
        setViewAsCards,
    } = props;

    const onViewTypeChange = (e) => setViewAsCards(e.target.value == "mosaico")

    return (
        <Grid item role="radiogroup" aria-label="Tipo de vista" className='digitalVaultView-viewType'>
            <label className='digitalVaultView-viewType-option' aria-label='Vista de mosaico'>
                <input type="radio" name="view" value="mosaico" checked={viewAsCards} onChange={onViewTypeChange} />
                <span className='digitalVaultView-viewType-img'>
                    <img aria-hidden='true' src="https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/CardViews.svg" />
                </span>
            </label>
            <label className='digitalVaultView-viewType-option' aria-label='Vista de lista (tabla)'>
                <input type="radio" name="view" value="lista" checked={!viewAsCards} onChange={onViewTypeChange} />
                <span className='digitalVaultView-viewType-img listview'>
                    <img aria-hidden='true' src="https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Table view.svg" />
                </span>
            </label>
        </Grid>
    )
}

export default ViewType